<div nz-row>
	<div nz-col nzSpan="24">
		<div nz-row>
			<div nz-col nzSpan="24">
				<nz-table #dynamicTable [nzData]="visibleIcons" [nzBordered]="bordered"
							[nzSimple]="simple" [nzLoading]="loading" [nzPaginationPosition]="position" [nzShowSizeChanger]="sizeChanger"
							[nzFrontPagination]="pagination" [nzShowPagination]="pagination" [nzFooter]="footer ? 'Here is the Footer' : null"
							[nzTitle]="title ? 'Here is the Title' : null" [nzSize]="size"
							class="kit__utils__table" [hidden]="privacyMode" style="overflow-x: hidden">
					<thead>
					<tr *ngIf="header">
						<th nzWidth="50px" nzCustomFilter [nzSortFn]="compareIcon">
							{{ 'word.icon' | translate}}
							<nz-filter-trigger [(nzVisible)]="iconFilterVisible" [nzActive]="iconFilterValue.length > 0" [nzDropdownMenu]="menuIcon">
								<i nz-icon nzType="filter"></i>
							</nz-filter-trigger>
						</th>
						<th nzWidth="150px" nzCustomFilter [nzSortFn]="compareIconName">
							{{ 'word.iconName' | translate}}
							<nz-filter-trigger [(nzVisible)]="iconNameFilterVisible" [nzActive]="iconNameFilterValue.length > 0"
												[nzDropdownMenu]="menuIconName">
								<i nz-icon nzType="filter"></i>
							</nz-filter-trigger>
						</th>
						<th nzWidth="150px" nzCustomFilter [nzSortFn]="compareSet">
							{{ 'word.set' | translate}}
							<nz-filter-trigger [(nzVisible)]="setFilterVisible" [nzActive]="setFilterValue.length > 0" [nzDropdownMenu]="menuSet">
								<i nz-icon nzType="filter"></i>
							</nz-filter-trigger>
						</th>
						<th nzWidth="33%" nzCustomFilter [nzSortFn]="compareMeaning">
							{{ 'word.meaning' | translate}}
							<nz-filter-trigger [(nzVisible)]="meaningFilterVisible" [nzActive]="meaningFilterValue.length > 0" [nzDropdownMenu]="menuMeaning">
								<i nz-icon nzType="filter"></i>
							</nz-filter-trigger>
						</th>
						<th nzWidth="67%" nzCustomFilter [nzSortFn]="compareDescription">
							{{ 'word.description' | translate}}
							<nz-filter-trigger [(nzVisible)]="descriptionFilterVisible" [nzActive]="descriptionFilterValue.length > 0"
												[nzDropdownMenu]="menuDescription">
								<i nz-icon nzType="filter"></i>
							</nz-filter-trigger>
						</th>
					</tr>
					</thead>
					<tbody>
					<ng-template ngFor let-data [ngForOf]="dynamicTable.data">
						<tr>
							<td><div *ngTemplateOutlet="icon"></div></td>
							<td>{{ data.iconName }}</td>
							<td>{{ data.set }}</td>
							<td>{{ data.meaning }}</td>
							<td>{{ data.description }}</td>
						</tr>


						<ng-template #icon>
							<div *ngIf="data.set === 'feather' || data.set === 'Feather'">
								<i-feather [name]="data.icon"></i-feather>
							</div>
							<div *ngIf="data.set !== 'feather' && data.set !== 'Feather'">
								<i nz-icon [nzType]="data.icon"></i>
							</div>
						</ng-template>
					</ng-template>
					</tbody>
				</nz-table>
			</div>
		</div>
	</div>
</div>

<nz-dropdown-menu #menuIcon="nzDropdownMenu">
	<div class="ant-table-filter-dropdown">
		<div class="search-box">
			<input type="text" nz-input [(ngModel)]="iconFilterValue" placeholder="{{ 'actions.searchFor' | translate :
			{searchItem : 'word.icon' | translate } }}"
				(ngModelChange)="filterIcon()"/>
		</div>
	</div>
</nz-dropdown-menu>

<nz-dropdown-menu #menuIconName="nzDropdownMenu">
	<div class="ant-table-filter-dropdown">
		<div class="search-box">
			<input type="text" nz-input [(ngModel)]="iconNameFilterValue" placeholder="{{ 'actions.searchFor' | translate :
			{searchItem : 'word.iconName' | translate } }}"
				(ngModelChange)="filterIconName()"/>
		</div>
	</div>
</nz-dropdown-menu>

<nz-dropdown-menu #menuSet="nzDropdownMenu">
	<div class="ant-table-filter-dropdown">
		<div class="search-box">
			<input type="text" nz-input [(ngModel)]="setFilterValue" placeholder="{{ 'actions.searchFor' | translate :
			{searchItem : 'word.set' | translate } }}"
				(ngModelChange)="filterSet()"/>
		</div>
	</div>
</nz-dropdown-menu>

<nz-dropdown-menu #menuMeaning="nzDropdownMenu">
	<div class="ant-table-filter-dropdown">
		<div class="search-box">
			<input type="text" nz-input [(ngModel)]="meaningFilterValue" placeholder="{{ 'actions.searchFor' | translate :
			{searchItem : 'word.meaning' | translate } }}"
				(ngModelChange)="filterMeaning()"/>
		</div>
	</div>
</nz-dropdown-menu>

<nz-dropdown-menu #menuDescription="nzDropdownMenu">
	<div class="ant-table-filter-dropdown">
		<div class="search-box">
			<input type="text" nz-input [(ngModel)]="descriptionFilterValue" placeholder="{{ 'actions.searchFor' | translate :
			{searchItem : 'word.description' | translate } }}"
				(ngModelChange)="filterDescription()"/>
		</div>
	</div>
</nz-dropdown-menu>
